import { Box, Stack } from "@mui/material";
import styles from "../../styles/pages/notification.module.scss";
import React, { useState } from "react";
import Wrapper from "../../layout/wrapper/Wrapper";
import NotificationLeftFilter from "../../components/NotificationLeftFilter/NotificationLeftFilter";
import NotificationTab from "../../components/NotificationTab/NotificationTab";
import { useQuery } from "react-query";
import {
    GetNotificationList,
    GetNotificationListByDate,
    GetNotificationListBySearch,
} from "../../api/functions/notification.api.js";
import { parseCookies } from "nookies";
import useFetch, { usePost } from "../../hooks/api/useFetch";
import axiosInstance from "../../api/axiosInstance";
import ApiLoader from "../../components/Loaders/ApiLoader";
import useInfinitePost from "../../hooks/api/useInfiniteFetch";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const index = () => {
    const [date, setDate] = useState({ startDate: "", endDate: "", type: "" });
    const [search, setSearch] = useState("");
    const getDataFromChild = (data) => {
        if (!(typeof data === typeof ".")) {
            if ("startDate" in data && "endDate" in data) {
                setDate(data);
            }
        } else {
            setSearch(data);
        }
    };

    const cookies = parseCookies();
    const userDetails = JSON?.parse(cookies?.userdetails || "{}");

    const [notificationTypeList, setNotificationTypeList] = useState([]);
    const [filterArchive, setFilterArchive] = useState(0);
    const [filters, setFilters] = useState(null);
    const handleFilterChange = (event) => {
        const { name, value } = event?.target;
        setFilters((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    };
    const resetSingleFilter = (name) => {
        setFilters((prev) => {
            return {
                ...prev,
                [name]: null,
            };
        });
    };
    const resetFilters = () => {
        setNotificationTypeList([]);
        setFilters(null);
    };
    const {
        data: notificationsList,
        isSuccess,
        isError,
        isLoading,
        refetch: refetchNotificationsList,
        hasNextPage,
        isFetching,
        fetchNextPage,
    } = useInfinitePost(
        [
            "notification",
            date?.startDate,
            date?.endDate,
            search,
            notificationTypeList,
            filterArchive,
            filters,
        ],
        `admin/notifications`,
        {
            search: search,
            notification_type_id: notificationTypeList.join(", "),
            archive: filterArchive,
            from: date?.startDate,
            to: date?.endDate,
            message_send_by: filters?.message_send_by
                ? filters?.message_send_by
                : null,
            message_send_to: filters?.message_send_to
                ? filters?.message_send_to
                : null,
            note_send_by: filters?.note_send_by ? filters?.note_send_by : null,
            note_send_to: filters?.note_send_to ? filters?.note_send_to : null,
        }
    );

    const updateNotification = async (data) => {
        await axiosInstance
            .post("admin/notification-status-update", data)
            .then((res) => {
                refetchNotificationsList();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const updateNotificationSeen = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            seen: notification?.seen ? 0 : 1,
        });
    };
    const updateNotificationArchive = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            archive: 1,
        });
    };

    const updateNotificationReadAll = () => {
        updateNotification({ read_all: "yes" });
    };
    const updateNotificationArchiveAll = () => {
        updateNotification({ archive_all: "yes" });
    };
    const updateNotificationDelete = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            delete: "yes",
        });
    };
    const updateNotificationDeleteAll = () => {
        updateNotification({ delete_all: "yes" });
    };

    return (
        <Wrapper>
            <ApiLoader loading={isLoading || isFetching} />
            {/* <Seo title="Notification" canonical={''} description={''} url={''} image={''} /> */}
            <Box className="main_body">
                <Box className={`commonBox ${styles.pageNoticmnBox}`}>
                    <Stack
                        direction="row"
                        flexWrap="wrap"
                        className={styles.notificationWrapper}
                    >
                        <NotificationLeftFilter
                            filterType={"notification"}
                            date={date}
                            getDataFromChild={getDataFromChild}
                            notificationTypeList={notificationTypeList}
                            setNotificationTypeList={setNotificationTypeList}
                            filters={filters}
                            handleFilterChange={handleFilterChange}
                            resetSingleFilter={resetSingleFilter}
                            resetFilters={resetFilters}
                        />

                        <Box
                            className={`${styles.tabsNotification} ${styles.tabpanelCenter}`}
                        >
                            <Box className={styles.tabsInner}>
                                {isLoading &&
                                !(
                                    search.length ||
                                    date.startDate.length ||
                                    date.endDate.length ||
                                    filterArchive
                                ) ? (
                                    ""
                                ) : isSuccess ||
                                  search.length ||
                                  date.startDate.length ||
                                  date.endDate.length ||
                                  filterArchive ? (
                                    <NotificationTab
                                        search={search}
                                        notifiactionsListIsLoading={isLoading}
                                        notifiactionsList={
                                            notificationsList?.pages
                                        }
                                        updateNotificationSeen={
                                            updateNotificationSeen
                                        }
                                        updateNotificationArchive={
                                            updateNotificationArchive
                                        }
                                        updateNotificationReadAll={
                                            updateNotificationReadAll
                                        }
                                        updateNotificationArchiveAll={
                                            updateNotificationArchiveAll
                                        }
                                        updateNotificationDelete={
                                            updateNotificationDelete
                                        }
                                        updateNotificationDeleteAll={
                                            updateNotificationDeleteAll
                                        }
                                        setFilterArchive={setFilterArchive}
                                        hasNextPage={hasNextPage}
                                        fetchNextPage={fetchNextPage}
                                        dateFiltersActive={
                                            date.startDate.length ||
                                            date.endDate.length
                                        }
                                        dateFilter={date}
                                        notificationFilters={
                                            notificationTypeList.length > 0 ||
                                            filters !== null
                                        }
                                        resetFilters={resetFilters}
                                    />
                                ) : (
                                    ""
                                )}
                            </Box>
                        </Box>
                    </Stack>
                </Box>
            </Box>
        </Wrapper>
    );
};

export default index;
